var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.71 44.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-link_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75.36a11.85,11.85,0,0,0-7,4.27A12.77,12.77,0,0,0,.07,13.11c0,3.86-.28,19.39.29,22,1.36,6.27,6.69,9.54,12.7,9.54,3.87,0,19.35.27,21.95-.28,5.62-1.2,9.63-5.91,9.63-12.63,0-3.67.26-19.65-.25-22C43.08,3.65,38,.06,31.68.07,27.8.07,12.35-.21,9.75.36Z",
    transform: "translate(0 0)",
    fill: "#4a66a2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.18,20.4l0-2.68H18.55v18l5.6.06V27.32c0-1.44-.09-2.44.63-3.56a3.59,3.59,0,0,1,2.65-1.67,3,3,0,0,1,2.75,1.44c.66,1,.55,2.31.55,3.68v8.58h5.59V27.55c0-2.48.42-5.62-.86-7.47a7.06,7.06,0,0,0-5.87-2.51,7.61,7.61,0,0,0-3.45.7,4.42,4.42,0,0,0-2,2.12Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.19 35.79 14.73 35.79 14.79 17.72 9.25 17.72 9.19 35.79",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6,8.62c-4,.53-3.2,6.53.83,6S15.52,8.09,11.6,8.62Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.2855115ea519139579a5b7db2651eaaa.svg";
export { ForwardRef as ReactComponent };